import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function PatientReviewIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66341 14.6673H4.39066C3.36041 14.6673 2.54095 14.166 1.80519 13.465C0.298989 12.03 2.77195 10.8833 3.71513 10.3217C5.01713 9.54644 6.52521 9.22758 7.99675 9.36504"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.3301 4.33398C10.3301 5.99084 8.98694 7.33398 7.33008 7.33398C5.67322 7.33398 4.33008 5.99084 4.33008 4.33398C4.33008 2.67713 5.67322 1.33398 7.33008 1.33398C8.98694 1.33398 10.3301 2.67713 10.3301 4.33398Z"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M13.5967 13.6007L14.6634 14.6673M14.1301 11.734C14.1301 10.4085 13.0555 9.33398 11.7301 9.33398C10.4046 9.33398 9.33008 10.4085 9.33008 11.734C9.33008 13.0595 10.4046 14.134 11.7301 14.134C13.0555 14.134 14.1301 13.0595 14.1301 11.734Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
